module.exports = __webpack_public_path__ + "static/img/company2.b317573.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/company2.png
// module id = UbPd
// module chunks = 1